import { inject, Signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { ActivatedRoute } from '@angular/router'
import { map } from 'rxjs'

/**
 * Best practice is to only use this function in a component that is a direct child of a router-outlet.
 * @param paramName
 */
export function routeParam<T>(paramName: string): Signal<T> {
  const route = inject(ActivatedRoute)
  return toSignal(route.params.pipe(map(params => params[paramName])), {
    initialValue: route.snapshot.params[paramName],
  })
}

export function parentRouteParam<T>(paramName: string): Signal<T> {
  const route = inject(ActivatedRoute)
  return toSignal(route.parent!.params.pipe(map(params => params[paramName])), {
    initialValue: route.snapshot.params[paramName],
  })
}
